import { derive } from 'store-utils';
import {
  AppOwnerRoleType,
  AppOwnerType,
  Nullable,
  OwnerForm,
} from 'common-types';
import { createStore } from 'store-utils';
import { filterDupAppOwners } from '../utils/aplications-owners-utils';

const baseStore = createStore<AppOwnersStoreState>(
  {
    assignAppOwnersRequest: {
      ownersFormList: [],
      owners: [],
      appIds: [],
      roles: [],
    },
    editAppOwnerRoleRequest: {
      prevOwners: [],
      ownersFormList: [],
      owners: [],
      appId: null,
      role: null,
    },
    assignedAppOwners: [],
    activeMembers: [],
    displaySelectedAppOwners: [],
    isLoading: false,
  },
  'AppOwnersStore Store',
);

const AppOwnersStore = derive(
  {
    appOwnersSuggestions: get => {
      const { activeMembers, assignedAppOwners } = get(baseStore);
      return filterDupAppOwners([...activeMembers, ...assignedAppOwners]);
    },
    disableAppOwnerAssignSubmit: get => {
      const { assignAppOwnersRequest } = get(baseStore);
      return (
        (assignAppOwnersRequest.owners.length === 0 &&
          assignAppOwnersRequest.ownersFormList.length === 0) ||
        assignAppOwnersRequest.roles.length === 0
      );
    },
    disableEditAppOwnerAssignSubmit: get => {
      const {
        editAppOwnerRoleRequest: { owners, ownersFormList, prevOwners },
      } = get(baseStore);

      const newOwners = [...owners, ...ownersFormList].map(o => o.email);
      const prevOwnersEmails = new Set(prevOwners.map(o => o.email));
      if (newOwners.length !== prevOwnersEmails.size) return false;
      return newOwners.every(email => prevOwnersEmails.has(email));
    },
    appOwnersFilterOptions: get => {
      const { assignedAppOwners, displaySelectedAppOwners } = get(baseStore);
      return assignedAppOwners.map(o => ({
        ...o,
        checked: displaySelectedAppOwners.includes(o.email),
      }));
    },
  },
  {
    proxy: baseStore,
  },
);
interface AppOwnersStoreState {
  assignAppOwnersRequest: {
    ownersFormList: OwnerForm[];
    owners: AppOwnerType[];
    appIds: string[];
    roles: AppOwnerRoleType[];
  };
  editAppOwnerRoleRequest: {
    prevOwners: AppOwnerType[];
    ownersFormList: OwnerForm[];
    role: Nullable<AppOwnerRoleType>;
    appId: Nullable<string>;
    owners: AppOwnerType[];
  };
  assignedAppOwners: AppOwnerType[];
  activeMembers: AppOwnerType[];
  displaySelectedAppOwners: string[];
  isLoading: boolean;
}

export default AppOwnersStore;
